import React from 'react';
import { Star } from 'lucide-react';
import { TESTIMONIALS } from '../data';

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-24 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-yellow-500/10 border border-yellow-500/20 text-yellow-300 text-sm font-medium tracking-wider uppercase mb-5">
            Testimonials
          </span>
          <h2 className="font-serif text-4xl sm:text-5xl font-bold text-white">Kind Words</h2>
          <p className="text-gray-400 mt-4 max-w-2xl mx-auto">
            What clients say about working with me.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t) => (
            <div
              key={t.id}
              className="bg-white/5 rounded-2xl p-6 border border-white/5 transition-all duration-300 hover:border-yellow-500/30"
            >
              <div className="flex items-center gap-4 mb-4">
                <img
                  src={t.image}
                  alt={t.name}
                  className="w-12 h-12 rounded-full object-cover border-2 border-yellow-500/30"
                />
                <div>
                  <div className="font-semibold text-white">{t.name}</div>
                  <div className="text-sm text-gray-400">{t.role}</div>
                </div>
              </div>
              <div className="flex gap-0.5 mb-3">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    size={16}
                    className={i < t.rating ? 'text-amber-400 fill-amber-400' : 'text-gray-600'}
                  />
                ))}
              </div>
              <p className="text-gray-300 text-sm leading-relaxed">{t.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;